<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Shape</title>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Home"
        transform="translate(-297.000000, -3821.000000)"
        fill="#999999"
        fill-rule="nonzero"
      >
        <g id="Footer" transform="translate(80.000000, 3433.000000)">
          <g id="Group-16" transform="translate(0.000000, 387.000000)">
            <path
              d="M232.658771,13 C232.658771,14.9145871 231.106691,16.4666667 229.192104,16.4666667 C227.277517,16.4666667 225.725438,14.9145871 225.725438,13 C225.725438,11.0854129 227.277517,9.53333333 229.192104,9.53333333 C231.106691,9.53333333 232.658771,11.0854129 232.658771,13 Z M240.458771,6.24 L240.458771,19.76 C240.458771,22.2489633 238.441068,24.2666667 235.952104,24.2666667 L222.432104,24.2666667 C219.943141,24.2666667 217.925438,22.2489633 217.925438,19.76 L217.925438,6.24 C217.925438,3.75103673 219.943141,1.73333333 222.432104,1.73333333 L235.952104,1.73333333 C238.441068,1.73333333 240.458771,3.75103673 240.458771,6.24 Z M235.258771,13 C235.258771,9.64947252 232.542632,6.93333333 229.192104,6.93333333 C225.841577,6.93333333 223.125438,9.64947252 223.125438,13 C223.125438,16.3505275 225.841577,19.0666667 229.192104,19.0666667 C230.801084,19.0666667 232.344165,18.4275018 233.481885,17.2897811 C234.619606,16.1520604 235.258771,14.60898 235.258771,13 L235.258771,13 Z M237.858771,6.06666667 C237.858771,5.1093731 237.082731,4.33333333 236.125438,4.33333333 C235.168144,4.33333333 234.392104,5.1093731 234.392104,6.06666667 C234.392104,7.02396023 235.168144,7.8 236.125438,7.8 C237.082731,7.8 237.858771,7.02396023 237.858771,6.06666667 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon-instagram",
};
</script>

<style scoped lang="scss">
svg:hover path {
  fill: #666;
}
</style>
